// Local match-logging reminders (no server / push infra). Fires a browser
// notification in the evening nudging the player to log the day's cricket.
// Works while the app / installed PWA is open or recently backgrounded.
const EN = "ct_reminder_enabled";
const TM = "ct_reminder_time";
const LAST = "ct_reminder_last";

export function getReminderPrefs() {
  return {
    enabled: localStorage.getItem(EN) === "1",
    time: localStorage.getItem(TM) || "19:00",
  };
}

export function setReminderEnabled(v) {
  localStorage.setItem(EN, v ? "1" : "0");
}

export function setReminderTime(t) {
  localStorage.setItem(TM, t);
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  return await Notification.requestPermission();
}

// Checked on an interval while the app is open. Fires at most once per day,
// only after the chosen time.
export function maybeFireReminder() {
  const { enabled, time } = getReminderPrefs();
  if (!enabled) return;
  if (!("Notification" in window) || Notification.permission !== "granted") return;

  const now = new Date();
  const today = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;
  if (localStorage.getItem(LAST) === today) return;

  const [h, m] = time.split(":").map(Number);
  const past = now.getHours() > h || (now.getHours() === h && now.getMinutes() >= m);
  if (!past) return;

  localStorage.setItem(LAST, today);
  try {
    const n = new Notification("CrickTrack 🏏", {
      body: "Played or practised today? Log it while it's still fresh.",
      icon: "/icon-192.png",
      badge: "/icon-192.png",
      tag: "ct-daily-log",
    });
    n.onclick = () => {
      window.focus();
      window.location.href = "/app/log";
    };
  } catch {}
}
